export default class OrderTrackingRepository {
  constructor({ orderTrackingService }) {
    this.orderTrackingService = orderTrackingService;
  }

  getOrderTracking(criteria) {
    return this.orderTrackingService.getOrderTracking(criteria);
  }

  putUserToCancelledStatus(userId) {
    return this.orderTrackingService.putUserToCancelledStatus(userId);
  }

  putUserToArchivedStatus(userId) {
    return this.orderTrackingService.putUserToArchivedStatus(userId);
  }

  putUserToRegisteredStatus(userId) {
    return this.orderTrackingService.putUserToRegisteredStatus(userId);
  }

  putUserToPaidStatus(userId) {
    return this.orderTrackingService.putUserToPaidStatus(userId);
  }

  putUserToCompleteStatus(userId) {
    return this.orderTrackingService.putUserToCompleteStatus(userId);
  }
}
